import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdmin } from "../context/AdminAuth";
import { apiErr } from "../lib/api";
import { inputCls } from "./ui";

export default function AdminLogin() {
  const { login } = useAdmin();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@streetsins.com");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await login(email, password); navigate("/admin"); }
    catch (ex) { setErr(apiErr(ex)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#070708] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <span className="font-display text-5xl tracking-widest text-white">STREETSINS</span>
          <p className="text-xs uppercase tracking-widest text-zinc-500 mt-2">Admin Console</p>
        </div>
        <form onSubmit={submit} className="bg-[#111113] border border-zinc-800 p-6 space-y-4">
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className={inputCls} data-testid="admin-login-email" />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className={inputCls} data-testid="admin-login-password" />
          {err && <p className="text-sm text-red-400">{err}</p>}
          <button type="submit" disabled={loading} className="btn-accent w-full py-3 text-xs font-bold uppercase tracking-widest disabled:opacity-60" data-testid="admin-login-submit-btn">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
